module.exports = __webpack_public_path__ + "img/hyjlb.55884b35.png";